import { useState } from "react";
import { motion } from "framer-motion";
import { Fragment } from "react";
import SVG from "react-inlinesvg";
import TextButton from "../TextButton";
import { Container } from "./styles";
import { useProjectStore } from "../../stores/projectStore.js";

const CharacterUpgradeOffer = ({ onUpgradeCast, upgrading }) => {
  const [showFaq, setShowFaq] = useState(false);
  const [optimisticShow, setOptimisticShow] = useState(true);
  const project = useProjectStore((state) => state.project);

  const handleNoThanks = async () => {
    await project.update({ showCharacterUpgradeOffer: false });
    setOptimisticShow(false);
  };

  if (!optimisticShow) return null;

  return (
    <Container>
      <div className="character-offer-header">
        <h1>Enhance your Characters</h1>
        <div className="header-right">
          <TextButton
            className="no-thanks"
            onClick={handleNoThanks}
            ariaLabel="Do not enhance characters"
          >
            No Thanks
          </TextButton>
          <div className="upgrade-container">
            <SVG
              className="free-badge"
              src="/assets/story-bible/free-badge.svg"
              aria-label="Free"
            />

            {!upgrading && (
              <button
                className="upgrade-button primary"
                disabled={upgrading}
                onClick={onUpgradeCast}
              >
                <SVG
                  src="/assets/AI-sparkle.svg"
                  aria-hidden="true"
                />
                <p>Enhance My Characters</p>
              </button>
            )}
            {upgrading && (
              <motion.button
                className="upgrade-button primary"
                initial={{
                  background: `linear-gradient(90deg,  var(--primary-cta) ${0}%, var(--grey-2) ${0}%)`,
                }}
                animate={{
                  background: `linear-gradient(90deg, var(--primary-cta)  90%, var(--grey-2) 90%)`,
                  transition: {
                    duration: 60,
                    ease: "linear",
                  },
                }}
              >
                <SVG
                  src="/assets/AI-sparkle.svg"
                  aria-hidden="true"
                />
                <p>Enhancing Your Characters</p>
              </motion.button>
            )}
          </div>
        </div>
      </div>
      <img
        src="/assets/story-bible/character-offer.png"
        alt="Character Upgrade"
        className="character-offer-image"
      />
      <p className="explainer">Story Bible just got a HUGE upgrade. Your characters can now have distinct traits like physical description, personality, dialogue style, and&nbsp;more.</p>
      <p className="explainer">
        Click <strong>Enhance my Characters</strong> to flesh out your characters with the new traits - for&nbsp;free.
      </p>

      {showFaq && (
        <Fragment>
          <h2>Frequently Asked Questions</h2>
          <table>
            <tr>
              <td className="q-or-a">Q</td>
              <td>
                <strong>Can I just keep using the old characters?</strong>
              </td>
            </tr>
            <tr>
              <td className="q-or-a">A</td>
              <td>Yup! You can keep our old characters as-is and Sudowrite will act the same. When you add new characters, they'll use the new&nbsp;format.</td>
            </tr>
            <tr>
              <td className="q-or-a beginning-of-question">Q</td>
              <td>
                <strong>What if I upgrade and I want to see how my characters were&nbsp;before?</strong>
              </td>
            </tr>
            <tr>
              <td className="q-or-a">A</td>
              <td>
                Click{" "}
                <SVG
                  className="inline-svg"
                  src="/assets/clock.svg"
                  aria-label="history"
                />{" "}
                to see your characters as they were before the&nbsp;upgrade.
              </td>
            </tr>
            <tr>
              <td className="q-or-a beginning-of-question">Q</td>
              <td>
                <strong>What's better about the new characters?</strong>
              </td>
            </tr>
            <tr>
              <td className="q-or-a">A</td>
              <td>
                You can add as many traits as you like, allowing for more complexity and nuance. Dialogue styles help your characters sound more distinct, and gone are the days of constantly updating
                Story Bible with every chapter to get the best&nbsp;results.
              </td>
            </tr>
            <tr>
              <td className="q-or-a beginning-of-question">Q</td>
              <td>
                <strong>Why are you doing this?</strong>
              </td>
            </tr>
            <tr>
              <td className="q-or-a">A</td>
              <td>
                Writers told us they found the old characters format too limiting. They couldn't fit their entire character sheets in Sudowrite, and important details had to be left out. The new
                character formats ensure Sudowrite knows all the important details about every character in your&nbsp;story.
              </td>
            </tr>
          </table>
        </Fragment>
      )}
      <button
        className="faq-button"
        onClick={() => setShowFaq(!showFaq)}
        aria-label={`${showFaq ? "Hide" : "Show"} FAQ`}
      >
        {showFaq ? "Hide" : "Show"} FAQ
      </button>
    </Container>
  );
};

export default CharacterUpgradeOffer;
